export default "/048cb1f2b29308e18768c65cfd51e426596a830c/39c069bc1b50ede44068ee575a7bad6a.png";